import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const MarketplaceRoute: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user || !['farmer', 'buyer'].includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default MarketplaceRoute;